import { render, staticRenderFns } from "./Cambiar_clave.vue?vue&type=template&id=431ebca8&"
import script from "./Cambiar_clave.vue?vue&type=script&lang=js&"
export * from "./Cambiar_clave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports